import { useActiveOrganization } from './useActiveOrganization';

/**
 * The organization the MCP admin screens operate on (its slug). See
 * resolveActiveOrganization for why this is not simply "cubicup".
 */
export function useMcpTenant(): string {
  return useActiveOrganization().slug;
}
